// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"tR","imageWrapper":"tS","image":"tT","overlay":"tU","isRental":"tV","rentalBadge":"tW","bottomGradient":"tX"};